import * as React from 'react'
import { createPortal } from 'react-dom'
import './Overlay.scss'

interface IProps {
  visible: boolean
  closeCallback: () => void
}

class Overlay extends React.PureComponent<IProps> {
  public componentDidMount () {
    document.addEventListener('keydown', this.escFn, false);
  }

  public componentWillUnmount() {
    document.removeEventListener('keydown', this.escFn, false);
  }

  public escFn = (e: KeyboardEvent) => {
    if (e.keyCode === 27) {
      this.props.closeCallback();
    }
  }

  public render() {
    const { visible, closeCallback } = this.props

    return visible
      ? createPortal(
          <div className="overlay">
            <div className="overlay__closebg" onClick={closeCallback} />
            {this.props.children}
          </div>,
          document.getElementById('___gatsby')
        )
      : null
  }
}

export default Overlay



// WEBPACK FOOTER //
// ./src/components/Overlay.tsx